function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmigLogoWhiteHorizonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "353px",
    height: "100px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.836
    },
    fill: "#fefffe",
    d: "M 46.5,-0.5 C 50.5,-0.5 54.5,-0.5 58.5,-0.5C 51.7026,1.48992 45.8693,5.15659 41,10.5C 33.7484,22.0009 26.7484,33.6676 20,45.5C 18.0014,43.5065 16.5014,41.1732 15.5,38.5C 19.9197,31.3291 24.0864,23.9958 28,16.5C 32.4599,8.86931 38.6265,3.20264 46.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.674
    },
    fill: "#fefffe",
    d: "M 130.5,2.5 C 132.144,2.28649 133.644,2.61983 135,3.5C 140.893,16.9532 147.06,30.2865 153.5,43.5C 151.833,44.8333 150.167,44.8333 148.5,43.5C 147.107,39.7143 145.441,36.0477 143.5,32.5C 136.189,31.3354 128.856,31.1687 121.5,32C 119.477,35.7299 117.644,39.5633 116,43.5C 114.506,44.7472 113.006,44.7472 111.5,43.5C 117.646,29.7189 123.98,16.0523 130.5,2.5 Z M 131.5,8.5 C 135.455,14.2375 138.788,20.4042 141.5,27C 135.472,27.8303 129.472,27.6636 123.5,26.5C 126.366,20.559 129.033,14.559 131.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.71
    },
    fill: "#fefffe",
    d: "M 251.5,2.5 C 252.5,2.5 253.5,2.5 254.5,2.5C 254.5,4.83333 254.5,7.16667 254.5,9.5C 253.5,9.5 252.5,9.5 251.5,9.5C 251.5,7.16667 251.5,4.83333 251.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.84
    },
    fill: "#fefffe",
    d: "M 30.5,3.5 C 31.552,3.35055 32.552,3.51722 33.5,4C 26.545,13.1149 20.2116,22.6149 14.5,32.5C 11.2649,17.9616 16.5983,8.29492 30.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.834
    },
    fill: "#fefffe",
    d: "M 57.5,3.5 C 66.8295,2.66489 74.8295,5.49822 81.5,12C 69.8476,11.9446 58.1809,11.4446 46.5,10.5C 49.7205,7.39406 53.3871,5.06073 57.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.675
    },
    fill: "#fefffe",
    d: "M 298.5,13.5 C 303.67,13.6671 307.503,16.0004 310,20.5C 310.5,28.4931 310.666,36.4931 310.5,44.5C 309.5,44.5 308.5,44.5 307.5,44.5C 307.719,43.325 307.386,42.325 306.5,41.5C 299.609,47.1405 293.109,46.8072 287,40.5C 284.601,31.0448 288.435,26.3782 298.5,26.5C 301.197,26.7027 303.864,27.036 306.5,27.5C 306.519,19.3585 302.519,16.1919 294.5,18C 292.409,19.6747 290.242,20.1747 288,19.5C 287.911,17.8866 288.745,16.7199 290.5,16C 293.31,15.2177 295.977,14.3844 298.5,13.5 Z M 294.5,29.5 C 298.548,29.3946 302.548,29.7279 306.5,30.5C 306.224,40.6532 301.224,43.8199 291.5,40C 288.374,35.3381 289.374,31.8381 294.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.825
    },
    fill: "#fefffe",
    d: "M 49.5,14.5 C 60.2825,14.021 70.9491,14.8543 81.5,17C 89.5637,19.3892 94.3971,24.5559 96,32.5C 87.39,24.2557 77.0567,20.589 65,21.5C 55.8445,22.4599 46.6778,22.6265 37.5,22C 38.5853,19.828 39.9186,17.828 41.5,16C 44.3647,15.8171 47.0314,15.3171 49.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.712
    },
    fill: "#fefffe",
    d: "M 154.5,14.5 C 155.833,14.5 157.167,14.5 158.5,14.5C 158.343,15.8734 158.51,17.2068 159,18.5C 163.173,14.8086 168.007,13.6419 173.5,15C 175.359,16.5578 176.859,18.3911 178,20.5C 181.636,14.8232 186.803,12.9899 193.5,15C 195.049,16.214 196.215,17.714 197,19.5C 197.5,27.8267 197.666,36.16 197.5,44.5C 196.5,44.5 195.5,44.5 194.5,44.5C 194.666,37.825 194.5,31.1583 194,24.5C 192.718,18.2764 189.218,16.4431 183.5,19C 181.622,20.5429 180.122,22.3762 179,24.5C 178.5,31.1583 178.334,37.825 178.5,44.5C 177.167,44.5 175.833,44.5 174.5,44.5C 174.901,36.4148 174.401,28.4148 173,20.5C 167.063,16.4704 162.397,17.8038 159,24.5C 158.5,31.1583 158.334,37.825 158.5,44.5C 157.167,44.5 155.833,44.5 154.5,44.5C 154.5,34.5 154.5,24.5 154.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.642
    },
    fill: "#fefffe",
    d: "M 209.5,14.5 C 222.302,12.9701 228.969,18.6367 229.5,31.5C 221.167,31.5 212.833,31.5 204.5,31.5C 206.057,39.2205 210.723,42.3871 218.5,41C 220.455,40.0467 222.122,38.7134 223.5,37C 228.198,36.8794 228.532,38.546 224.5,42C 207.631,48.1567 199.798,42.3234 201,24.5C 202.261,19.7452 205.095,16.4118 209.5,14.5 Z M 211.5,17.5 C 218.773,16.4768 223.44,19.4768 225.5,26.5C 218.532,27.497 211.532,27.8303 204.5,27.5C 205.276,23.0601 207.61,19.7268 211.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.631
    },
    fill: "#fefffe",
    d: "M 231.5,14.5 C 232.833,14.5 234.167,14.5 235.5,14.5C 235.34,16.1992 235.506,17.8659 236,19.5C 239.093,15.2051 243.26,13.5384 248.5,14.5C 248.5,15.8333 248.5,17.1667 248.5,18.5C 242.522,17.2447 238.356,19.578 236,25.5C 235.5,31.8246 235.334,38.1579 235.5,44.5C 234.167,44.5 232.833,44.5 231.5,44.5C 231.5,34.5 231.5,24.5 231.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.889
    },
    fill: "#fefffe",
    d: "M 251.5,14.5 C 252.5,14.5 253.5,14.5 254.5,14.5C 254.5,24.5 254.5,34.5 254.5,44.5C 253.5,44.5 252.5,44.5 251.5,44.5C 251.5,34.5 251.5,24.5 251.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.682
    },
    fill: "#fefffe",
    d: "M 266.5,14.5 C 273.016,13.237 278.516,14.9036 283,19.5C 283.483,20.448 283.649,21.448 283.5,22.5C 280.401,22.9077 278.067,21.741 276.5,19C 271.141,16.6726 266.641,17.8392 263,22.5C 258.803,32.4361 261.803,38.7695 272,41.5C 275.328,40.9197 278.161,39.4197 280.5,37C 281.944,36.2195 283.277,36.3861 284.5,37.5C 280.303,44.1157 274.303,46.2823 266.5,44C 260.213,41.0321 257.213,36.0321 257.5,29C 257.353,22.1129 260.353,17.2795 266.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.684
    },
    fill: "#fefffe",
    d: "M 313.5,14.5 C 314.833,14.5 316.167,14.5 317.5,14.5C 317.343,15.8734 317.51,17.2068 318,18.5C 322.517,14.7576 327.684,13.591 333.5,15C 336.473,17.4477 337.973,20.6144 338,24.5C 338.5,31.1583 338.666,37.825 338.5,44.5C 337.167,44.5 335.833,44.5 334.5,44.5C 334.901,36.4148 334.401,28.4148 333,20.5C 326.869,16.643 321.869,17.9763 318,24.5C 317.5,31.1583 317.334,37.825 317.5,44.5C 316.167,44.5 314.833,44.5 313.5,44.5C 313.5,34.5 313.5,24.5 313.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.836
    },
    fill: "#fefffe",
    d: "M 9.5,17.5 C 10.2389,17.369 10.9056,17.5357 11.5,18C 8.89479,24.8308 9.06145,31.6641 12,38.5C 18.2472,49.9964 24.7472,61.3297 31.5,72.5C 28.059,74.0063 24.8924,73.6729 22,71.5C 16.7464,62.6611 11.7464,53.6611 7,44.5C 3.15111,34.9773 3.98444,25.9773 9.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.836
    },
    fill: "#fefffe",
    d: "M 67.5,25.5 C 71.0071,24.9935 74.1737,25.6602 77,27.5C 81.9201,35.6717 86.5868,44.005 91,52.5C 93.9402,59.7166 94.6069,67.0499 93,74.5C 87.8432,84.0139 86.6765,83.5139 89.5,73C 88.9205,68.0211 87.7538,63.1878 86,58.5C 79.577,47.5937 73.4103,36.5937 67.5,25.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.831
    },
    fill: "#fefffe",
    d: "M 80.5,28.5 C 92.8921,29.7594 98.8921,36.9261 98.5,50C 98.6182,53.0272 98.1182,55.8605 97,58.5C 92.7698,47.6984 87.2698,37.6984 80.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.815
    },
    fill: "#fefffe",
    d: "M -0.5,52.5 C -0.5,50.1667 -0.5,47.8333 -0.5,45.5C 0.163485,43.9581 0.830151,42.2914 1.5,40.5C 6.30524,50.7769 11.6386,60.7769 17.5,70.5C 11.5217,70.4189 6.68833,67.7522 3,62.5C 1.51368,59.1498 0.347016,55.8165 -0.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.875
    },
    fill: "#fefffe",
    d: "M 111.5,48.5 C 114.898,48.1796 118.232,48.513 121.5,49.5C 124.659,56.4878 128.326,63.1545 132.5,69.5C 136.167,62.8333 139.833,56.1667 143.5,49.5C 146.768,48.513 150.102,48.1796 153.5,48.5C 153.5,62.1667 153.5,75.8333 153.5,89.5C 150.5,89.5 147.5,89.5 144.5,89.5C 144.666,81.4931 144.5,73.4931 144,65.5C 141.333,70.8333 138.667,76.1667 136,81.5C 133.667,82.8333 131.333,82.8333 129,81.5C 126.588,76.3413 123.921,71.3413 121,66.5C 120.5,74.1594 120.334,81.8261 120.5,89.5C 117.5,89.5 114.5,89.5 111.5,89.5C 111.5,75.8333 111.5,62.1667 111.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.865
    },
    fill: "#fefffe",
    d: "M 168.5,48.5 C 186.886,47.3867 195.386,56.0534 194,74.5C 188.853,88.3245 179.353,92.8245 165.5,88C 155.641,80.7462 152.808,71.2462 157,59.5C 159.495,54.353 163.329,50.6863 168.5,48.5 Z M 170.5,56.5 C 181.739,55.9091 186.572,61.2424 185,72.5C 181.529,82.5463 175.529,84.5463 167,78.5C 162.275,70.2839 163.442,62.9505 170.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.873
    },
    fill: "#fefffe",
    d: "M 196.5,48.5 C 203.841,48.3337 211.174,48.5003 218.5,49C 227.831,52.3408 232.498,59.0074 232.5,69C 232.428,79.0459 227.761,85.7125 218.5,89C 211.174,89.4997 203.841,89.6663 196.5,89.5C 196.5,75.8333 196.5,62.1667 196.5,48.5 Z M 205.5,56.5 C 220.17,54.9987 225.67,61.332 222,75.5C 221.215,77.286 220.049,78.786 218.5,80C 214.3,81.3674 209.967,81.8674 205.5,81.5C 205.5,73.1667 205.5,64.8333 205.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.854
    },
    fill: "#fefffe",
    d: "M 234.5,48.5 C 244.167,48.5 253.833,48.5 263.5,48.5C 263.5,51.1667 263.5,53.8333 263.5,56.5C 256.833,56.5 250.167,56.5 243.5,56.5C 243.5,59.1667 243.5,61.8333 243.5,64.5C 249.167,64.5 254.833,64.5 260.5,64.5C 260.5,67.1667 260.5,69.8333 260.5,72.5C 254.833,72.5 249.167,72.5 243.5,72.5C 243.5,75.5 243.5,78.5 243.5,81.5C 250.167,81.5 256.833,81.5 263.5,81.5C 263.5,84.1667 263.5,86.8333 263.5,89.5C 253.833,89.5 244.167,89.5 234.5,89.5C 234.5,75.8333 234.5,62.1667 234.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.878
    },
    fill: "#fefffe",
    d: "M 266.5,48.5 C 274.174,48.3336 281.841,48.5003 289.5,49C 297.062,53.1909 299.562,59.3576 297,67.5C 296.089,70.5755 294.256,72.9089 291.5,74.5C 294.124,79.585 297.124,84.4183 300.5,89C 296.789,89.8253 293.122,89.6586 289.5,88.5C 287.292,84.5834 284.959,80.75 282.5,77C 280.19,76.5034 277.857,76.3367 275.5,76.5C 275.5,80.8333 275.5,85.1667 275.5,89.5C 272.5,89.5 269.5,89.5 266.5,89.5C 266.5,75.8333 266.5,62.1667 266.5,48.5 Z M 275.5,56.5 C 279.182,56.3347 282.848,56.5014 286.5,57C 290.652,61.0436 290.319,64.7103 285.5,68C 282.183,68.4983 278.85,68.665 275.5,68.5C 275.5,64.5 275.5,60.5 275.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9
    },
    fill: "#fefffe",
    d: "M 302.5,48.5 C 304.857,48.3367 307.19,48.5034 309.5,49C 316.12,57.0755 322.62,65.2422 329,73.5C 329.5,65.1733 329.666,56.84 329.5,48.5C 332.5,48.5 335.5,48.5 338.5,48.5C 338.5,62.1667 338.5,75.8333 338.5,89.5C 335.813,89.6641 333.146,89.4974 330.5,89C 324,81.1667 317.5,73.3333 311,65.5C 310.5,73.4931 310.334,81.4931 310.5,89.5C 307.833,89.5 305.167,89.5 302.5,89.5C 302.5,75.8333 302.5,62.1667 302.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.839
    },
    fill: "#fefffe",
    d: "M 52.5,99.5 C 48.5,99.5 44.5,99.5 40.5,99.5C 48.361,96.9633 54.861,92.2966 60,85.5C 66.3333,74.8333 72.6667,64.1667 79,53.5C 80.6965,55.5596 81.8631,57.8929 82.5,60.5C 77.4396,70.9546 71.6063,80.9546 65,90.5C 61.2101,94.1384 57.0435,97.1384 52.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.818
    },
    fill: "#fefffe",
    d: "M 1.5,66.5 C 4.22545,67.713 6.55878,69.5464 8.5,72C 16.5609,75.7392 25.0609,77.5725 34,77.5C 42.817,76.7175 51.6503,76.3841 60.5,76.5C 60.1135,81.4443 57.4468,83.9443 52.5,84C 41.7976,84.7763 31.1309,84.4429 20.5,83C 11.1861,80.848 4.85275,75.348 1.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.836
    },
    fill: "#fefffe",
    d: "M 83.5,66.5 C 87.4265,77.8709 84.0932,86.7042 73.5,93C 70.9761,94.5132 68.3094,95.1799 65.5,95C 72.3856,86.0627 78.3856,76.5627 83.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.398
    },
    fill: "#fefffe",
    d: "M 352.5,83.5 C 352.5,84.5 352.5,85.5 352.5,86.5C 349.636,90.3972 346.136,91.0639 342,88.5C 339.995,81.5098 342.495,78.6764 349.5,80C 350.636,81.1451 351.636,82.3117 352.5,83.5 Z M 349.5,83.5 C 350.776,84.3864 350.776,85.3864 349.5,86.5C 348.913,85.7666 348.913,84.7666 349.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.828
    },
    fill: "#fefffe",
    d: "M 17.5,87.5 C 18.0968,86.8614 18.9302,86.528 20,86.5C 30.8273,87.1112 41.6606,87.7778 52.5,88.5C 40.6365,98.0315 28.9699,97.6982 17.5,87.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmigLogoWhiteHorizonal);
export default __webpack_public_path__ + "static/media/AMIG-Logo_White_Horizonal.e9b789b64b1258fe5c6a704202a76bb1.svg";
export { ForwardRef as ReactComponent };